import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "statusMessage"]
  
  connect() {
    // Form will be the controller's element
  }
  
  submit(event) {
    event.preventDefault()
    
    const form = this.element
    const formData = new FormData(form)
    
    // Show loading state
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.value = 'Generating...'
      this.submitButtonTarget.classList.add('opacity-75', 'cursor-not-allowed')
    }
    
    // Create EventSource for SSE
    const url = form.action
    const params = new URLSearchParams(formData)
    const eventSource = new EventSource(`${url}?${params}`)
    
    eventSource.addEventListener('status', (event) => {
      const data = JSON.parse(event.data)
      this.updateStatus(data)
    })
    
    eventSource.addEventListener('result', (event) => {
      const data = JSON.parse(event.data)
      eventSource.close()
      
      // Store results and redirect to show them
      sessionStorage.setItem('generationResults', JSON.stringify(data))
      window.location.href = form.action.replace('/generate', '/generate')
    })
    
    eventSource.addEventListener('error', (event) => {
      eventSource.close()
      
      if (event.data) {
        const data = JSON.parse(event.data)
        alert(`Error: ${data.error}`)
      } else {
        alert('An error occurred during generation')
      }
      
      // Reset button
      if (this.hasSubmitButtonTarget) {
        this.submitButtonTarget.disabled = false
        this.submitButtonTarget.value = 'Generate Scenarios'
        this.submitButtonTarget.classList.remove('opacity-75', 'cursor-not-allowed')
      }
    })
  }
  
  updateStatus(data) {
    let message = ''
    switch(data.status) {
      case 'fetching_menu':
        message = 'Fetching menu data...'
        break
      case 'generating_scenarios':
        message = 'Generating scenarios with AI...'
        break
      case 'validating':
        message = `Validating scenarios... ${data.progress || ''}`
        break
    }
    
    if (this.hasStatusMessageTarget) {
      this.statusMessageTarget.textContent = message
    } else if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.value = message
    }
  }
}